import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { volumes, lessonGroups } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-265" data-mp="cp0zcd90b28x">
      <div className="max-w-6xl mx-auto" data-id="element-266" data-mp="cnpv6cbnfsha">
        <div className="text-center mb-16" data-id="element-267" data-mp="7po537ft2swb">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-268" data-mp="7pxrym5k0jxs">
            The Professional Library
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-269" data-mp="3c3w9i35ffu48">
            7 complete volumes for real massage practice
          </h2>
          <p className="text-xl text-terracotta-dark" data-id="element-270" data-mp="3pwc7gpjh11ya">
            From professional foundations to advanced session design · Nothing
            to build from zero
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-271" data-mp="2xd5fqpk9ykyh">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper rounded-2xl border ${volume.featured ? 'border-terracotta shadow-[0_10px_30px_-18px_rgba(138,74,43,0.45)]' : 'border-warmgray'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-272" data-mp="2sf3xg6uoapo2" data-mpi={index}>
              {volume.featured && <div className="absolute top-6 right-[-35px] bg-terracotta-deep text-paper font-bold text-xs py-1 px-10 rotate-45 shadow-sm" data-id="element-273" data-mp="24gxb2keif4c3">
                  MOST USED
                </div>}

              <div className="mb-6 pr-16" data-id="element-274" data-mp="3fv1cgbnffur6">
                <div className="text-terracotta font-bold text-sm uppercase tracking-wider" data-id="element-275" data-mp="3ftrfjpsb8sm4">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-charcoal" data-id="element-276" data-mp="1bs9bsxac4s7m">
                  {volume.title}
                </h3>
              </div>

              <p className="text-charcoal font-medium mb-6 italic border-l-2 border-terracotta/50 pl-4" data-id="element-277" data-mp="1pp4w5lw1e62z">
                {volume.subtitle}
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-278" data-mp="x3my100cw8ii">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-279" data-mp="t2ta46mwytpm">
                    <CheckCircle2 size={18} className="text-terracotta shrink-0 mt-0.5" aria-hidden="true" data-id="element-280" data-mp="16swmm5vzr91v" />
                    <span className="text-charcoal-soft text-sm" data-id="element-281" data-mp="ebkcpbcrs41x">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-sand border border-warmgray rounded-xl p-4 mt-auto" data-id="element-282" data-mp="2l0uodrw3u0se">
                <span className="text-terracotta-deep font-bold block mb-1" data-id="element-283" data-mp="2prb3rhjhjwhe">
                  Result:
                </span>
                <p className="text-charcoal-soft text-sm" data-id="element-284" data-mp="2c0pi5l2nd8ft">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-12 bg-sand border border-warmgray rounded-2xl p-8" data-id="element-285" data-mp="2gwwq1jelsu0e">
          <div className="flex items-center gap-3 mb-8" data-id="element-286" data-mp="1jb8vl41pklri">
            <BookOpen size={20} className="text-terracotta" aria-hidden="true" data-id="element-287" data-mp="1j9o09c7kkysl" />
            <h3 className="text-lg font-bold text-charcoal" data-id="element-288" data-mp="1obddmyi9loju">
              The 150 Ready-to-Use Massage Sessions, organized
            </h3>
          </div>
          <ol className="grid md:grid-cols-2 gap-x-8 gap-y-5" data-id="element-289" data-mp="1yta5evw1edmc">
            {lessonGroups.map(group => <li key={group.title} className="border-l-2 border-terracotta/40 pl-4" data-id="element-290" data-mp="1urf2jmygjs6g">
                <p className="text-xs font-semibold uppercase tracking-wider text-terracotta-dark" data-id="element-291" data-mp="1ptvexwfve31u">
                  {group.range}
                </p>
                <p className="font-bold text-charcoal" data-id="element-292" data-mp="2ih9f03ev7eq6">{group.title}</p>
                <p className="text-sm text-charcoal-muted" data-id="element-293" data-mp="2ii0y4er9zjzk">{group.detail}</p>
              </li>)}
          </ol>
        </motion.div>
      </div>
    </section>;
}